import Marquee from "react-fast-marquee";

const ITEMS = [
  "100% Quality Commitment",
  "500+ Business Customers",
  "Fast & Reliable Delivery",
  "Bulk Orders Welcome",
  "Custom Packaging",
  "Competitive Wholesale Pricing",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="marquee" className="border-y border-[var(--border)] bg-[var(--green-deep)] py-6">
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-display text-2xl italic text-white/95 md:text-3xl">{t}</span>
            <span className="text-2xl text-[var(--gold)]">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
